export const bankingDepositsTableColumns = [
  { label: 'Status do Depósito', value: 'status' },
  { label: 'Nº da Nota', value: 'fiscal_document_number' },
  { label: 'Data da Solicitação', value: 'created_at' },
  { label: 'Autor', value: 'requested_by' },
  { label: 'Via', value: 'payment_method' },
  { label: 'Valor Requisitado', value: 'requested_total' },
  { label: 'Valor Pago', value: 'total_value' },
  { label: 'Data de Pagamento', value: 'paid_at' },
  { label: 'Ações', value: 'actions', className: 'w-9' },
];
